import React from 'react';
import { PropTypes } from 'prop-types';
import { colors } from '@ublend-npm/aulaui-next-web/themes/default';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { ChipWrapper, TextWrapper } from './Chip.styled';
import { ENTER } from '../../../utils/keyCodes';

const Chip = ({
  title,
  icon: Icon,
  checked,
  disabled,
  hasError,
  size,
  onChange,
  onDelete,
  ...props
}) => (
  <ChipWrapper
    size={size}
    tabIndex="0"
    role="button"
    checked={checked}
    disabled={disabled}
    hasError={hasError}
    onClick={() => onChange(!checked)}
    onKeyDown={(e) => e.keyCode === ENTER && onChange(!checked)}
    {...props}
  >
    <Icon
      style={{
        fontSize: '20px',
        color: `${checked ? colors.purple : colors.grey6}`,
      }}
    />
    <TextWrapper>{title}</TextWrapper>
    {onDelete !== null && (
      <HighlightOffIcon
        tabIndex="0"
        role="button"
        onClick={onDelete}
        onKeyDown={(e) => e.keyCode === ENTER && onDelete()}
        style={{
          fontSize: '20px',
          color: `${checked ? colors.purple : colors.grey6}`,
        }}
      />
    )}
  </ChipWrapper>
);

Chip.defaultProps = {
  title: '',
  size: 'default',
  checked: false,
  disabled: false,
  hasError: false,
  onDelete: null,
  onChange: () => {},
  icon: () => <span />,
};

Chip.propTypes = {
  title: PropTypes.string,
  size: PropTypes.string,
  icon: PropTypes.elementType,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  hasError: PropTypes.bool,
  onChange: PropTypes.func,
  onDelete: PropTypes.func,
};

export default Chip;
